<template>
		<div>
			<header class="title">
				<div>
					<div class="logo">
						<el-row>
							<el-col :span="18">
								<img src="../../../images/logo.png" alt="">
								<p> 中经天平司法鉴定中心 </p>
								<p> Hebei Zhongjing Tianping Judicial Expertise Center </p>
							</el-col>
							<el-col :span="6">
							</el-col>
						</el-row>
					</div>
					<div class="nav">
						<ul>
							<li v-for="(item, index) in navList" :key="index" :class="{active: navActive === index}"
								@click="route(item, index)">
								<el-dropdown trigger="hover" v-if="index === 1">
									<span class="el-dropdown-link">
										{{ item.name }}
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item v-for="(item, index) in dropdownItem" :key="index" >
											<p @click="dropdown(item, index)">	{{ item.name }}</p>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<span v-if="index !== 1">
									{{ item.name }}
								</span>
							</li>
						</ul>
					</div>
				</div>
			</header>
			<main>
				<div class="pdfBox">
					<p class="title">
						首页 > 电子证据详情
					</p>
					<div class="left">
						<p class="titleWord">司法进度存证文件</p>
						<!-- 左侧菜单栏 -->
						<div class="leftMenu">
							<p v-for="(item, index) in pdfInfos" :class="{active: pdfActive === index}" :key="index" @click="changeUrl(item.url,index)">{{item.name}}</p>
						</div>
						<!-- 中间内容部分 -->
						<div class="centerBox">
							<el-button-group style='display: flex;justify-content: center;align-items: center; margin-bottom: 15px;'>
								<el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>
								<el-button type="primary" size="mini" @click="nextPage" style="margin:0 15px">
									下一页
									<i class="el-icon-arrow-right el-icon--right"></i>
								</el-button>
								<div style="color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>
							</el-button-group>
							<pdf :page="pageNum" :src="pdfUrl" @progress="loadedRatio = $event" @num-pages="pageTotalNum = $event" style="border: 10px solid #444;box-sizing: border-box;"></pdf>
						</div>
					</div>
					<!-- 即时聊天部分 -->
					<div class="chatModel">
						<p class="titleChat">在线客服</p>
					</div>
				</div>
			</main>
			<div class="footer">
				<div>
					<p>
						<span> 地址: 河北省石家庄市鹿泉区昌盛大街68号 </span>
					</p>
					<p>
						<span> 电话: 0311-89929485 </span>
					</p>
					<p>
						<span> E-mail: support@sfjdzx.org.cn </span>
					</p>
				</div>
			</div>

		</div>
</template>

<script>
import pdf from 'vue-pdf';
import axios from 'axios'
import '../../assets/css/index.less'
export default {
	name: 'Pdf',
	components: {
		pdf
	},
	data() {
		return {
			pdfInfos:[],
			pdfUrl:'',
			fayuanName: '河南省高级人民法院',
			navActive: 5,
			pdfActive:0,
			dropdownItem: [{
					path: 'cunZheng',
					name: '司法存证'
				},
				{
					path: 'zhuiSu',
					name: '数字资产追溯'
				},
				{
					path: 'baoHu',
					name: '隐私数据保护'
				}
			],
			navList: [{
					path: 'homePage',
					name: '首页'
				},
				{
					path: 'cunZheng',
					name: '产品'
				},
				{
					path: 'fuWu',
					name: '服务'
				},
				{
					path: 'news',
					name: '新闻'
				},
				// { path: '', name: '验证平台' },
				{
					path: '',
					name: '司法电子证据云'
				},
				{
					path: 'jrhy',
					name: '金融类核验入口'
				}
			],
			// url: 'http://tpjk-api.bjzjtp.com/uploads/local-storage/1/overdue/29388/BFQU1Bcs6tV1N06U47Y4hW9646.pdf',
			pageNum: 1,
			pageTotalNum: 1, //总页数
			loadedRatio: 0 //当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成了
		};
	},
	methods: {
		changeUrl(url,index){
			this.pdfUrl = url
			this.pdfActive = index
		},
		// 上一页
		prePage() {
			let page = this.pageNum;
			page = page > 1 ? page - 1 : this.pageTotalNum;
			this.pageNum = page;
		},

		// 下一页
		nextPage() {
			let page = this.pageNum;
			page = page < this.pageTotalNum ? page + 1 : 1;
			this.pageNum = page;
		},
		// 导航跳转
		route(item, index) {
			if (index === 4) {
				this.bianliang = 4;
				window.open('https://evidence.bjzjtp.com/')
			} else {
				this.$router.push({path:'/',query: {path:item.path,id:index}})
			}
		},
		// 产品栏目菜单切换
		dropdown(item,index) {
			this.path = item.path
			this.pageNum = 1
		}
	},
	created(){

	},
	mounted() {
		let that = this;
		that.pdfInfos = JSON.parse(sessionStorage.getItem('pdfInfos'))
		that.pdfUrl = that.pdfInfos[0].url
	},
};
</script>

<style lang="less">
	.pdfBox{
		width: 83%;
		margin: 0 auto;
		overflow: hidden;
		padding-bottom: 30px;
		box-sizing: border-box;
		.title{
			width: 100%;
			height: 75px;
			line-height: 75px;
			font-family: PingFangRegular;
			font-size: 16px;
			color: #000000;
			letter-spacing: 0;
			border-bottom: 1px solid rgba(151,151,151,0.50);
			margin-bottom: 20px;
		}
		.left{
			width: 70%;
			height: 600px;
			overflow: hidden;
			background: #F4F6FA;
			border-radius: 5px 5px 0 0;
			border: 1px solid rgba(151,151,151,0.20);
			box-shadow: 0 5px 10px 0 rgba(0,0,0,0.10);
			border-radius: 5px;
			border-radius: 5px;
			float: left;
			.titleWord{
				width: 100%;
				background: #444444;
				height: 40px;
				line-height: 40px;
				padding-left: 15px;
				box-sizing: border-box;
				font-family: PingFangSemibold;
				font-size: 14px;
				color: #FFFFFF;
				letter-spacing: 0;
			}
			.leftMenu{
				width: 20%;
				height: 100vh;
				background: #fff;
				float: left;
				padding: 20px;
				box-sizing: border-box;
				p{
					width: 100%;
					font-family: PingFangRegular;
					font-size: 14px;
					color: #444444;
					letter-spacing: 0;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					margin-bottom: 10px;
					cursor: pointer;
				}
				.active{
					color: #BB0600;
					font-weight: bold;
				}
			}
			.centerBox{
				width: 80%;
				height: 100%;
				overflow-y: auto;
				background: #F4F6FA;
				float: left;
				padding:15px;
				box-sizing: border-box;
				padding-bottom: 70px;
			}
		}
		.chatModel{
			width: 29%;
			height: 600px;
			float: right;
			overflow: hidden;
			border-radius: 5px 5px 0 0;
			background: #F4F6FA;
			border: 1px solid rgba(151,151,151,0.20);
			box-shadow: 0 5px 10px 0 rgba(0,0,0,0.10);
			.titleChat{
				width: 100%;
				background: #BB0600;
				height: 40px;
				line-height: 40px;
				padding-left: 15px;
				box-sizing: border-box;
				font-family: PingFangSemibold;
				font-size: 14px;
				color: #FFFFFF;
				letter-spacing: 0;
			}
		}
	}
</style>
